import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import styles from "./Company.m.scss";

function CompanyHeader(props) {
  const { theme } = props;
  return (
    <div className={classnames(theme.header)}>
      <div>{"Id"}</div>
      <div>{"Краткое наименование"}</div>
      <div>{"Полное наименование"}</div>
      <div>{"ИНН"}</div>
      <div className={classnames(theme.controls)} />
    </div>
  );
}

CompanyHeader.displayName = "CompanyHeader";

CompanyHeader.propTypes = {
  theme: PropTypes.object,
};

CompanyHeader.defaultProps = {};

export default themr("@lifepay/CompanyHeader", styles)(CompanyHeader);



// WEBPACK FOOTER //
// ./src/components/list-items/compact/Company/Header.js